import React, { useContext } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { AppContext } from '../../contexts/AppContext';
import planALogo from '../../images/plan-a.png';

export default function StudioA() {
  const { useMobileView } = useContext(AppContext);

  const desktop = {
    padding: '16px 16px',
    margin: '0px 0px',
    width: '100%',
    paddingBottom: '160px'
  };

  const mobile = {
    padding: '16px 16px',
    margin: '0px 0px',
    width: '100%',
  };

  return (
    <Grid
      container
      spacing={3}
      sx={useMobileView ? mobile : desktop}
    >
      <Grid item xs={12} container justifyContent="center" alignItems="flex-end">
            <img src={planALogo} alt="Plan A Logo" />
            <span style={{ textDecoration: 'underline', fontSize: '28px' }}>Studio</span>
          </Grid>
      <Grid item xs={12}>
        <Typography align="center">
          Welcome to <b>Studio <span style={{ color: 'red' }}>A</span></b>. 
        </Typography>
        <Typography align="center">
          Coming soon you'll find exclusive resources to support you on your creative journey. 
        </Typography>
        <Typography align="center">
          Audio, video and downloadable text materials to accompany <b>Plan <span style={{ color: 'red' }}>A </span></b>
          services, or to use on your own if your project is not yet ready to collaborate with
          <b> Plan <span style={{ color: 'red' }}>A</span></b>.   
        </Typography>
        <Typography align="center">
          These are Adrienne's  favorite pieces of expert wisdom boiled down to the most valuable and useful tools 
          to propel your project forward.    
        </Typography>
        <br />
        <br />
        <Typography align="center">
          Check back soon for more!
        </Typography>
      </Grid>
    </Grid>
  );
}
